export default '3.6.0' as string
